module.exports = __webpack_public_path__ + "static/mr-press-15-4efaf390630578a8116d45f832464a9a.jpg";